import {TransactionListItem} from '@/types/types'

export const getResourceName = (item: TransactionListItem): string =>
  item.extra_data?.name || item.extra_data?.symbol || item.source_type

export const getResourceIcon = (item: TransactionListItem): string =>
  item.extra_data?.icon ||
  item.extra_data?.icon_img ||
  item.extra_data?.img ||
  ''

export const getResourceDescription = (
  item: TransactionListItem,
  language: string
): string => {
  const description = item.extra_data?.description
  if (!description) return ''
  if (typeof description === 'string') return description
  return description[language] || description.en || ''
}

export const formatReportDate = (iso: string) => {
  if (!iso) return '—'
  const date = new Date(iso)
  if (isNaN(date.getTime())) return '—'
  return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  })}`
}

export const toRequestDate = (value: string, endOfDay = false): string => {
  if (!value) return ''
  return `${value} ${endOfDay ? '23:59:59' : '00:00:00'}`
}
